export const canTrack = (): boolean => {
	if (typeof window === "undefined") {
		return false;
	}
	return true;
};
